import { initializeMultiPageTest, initializeMultiPageTestResults, quizMeButton } from '../audio-video-qa-base';

const video = document.querySelector('#media-player');
const watchAgain = document.querySelector('.watch-again');

if (watchAgain) {
    const videoJsPlayer = videojs('media-player');
    const quizButton = document.querySelector('#quiz-button');
    let tracked = false;

    watchAgain.addEventListener('click', () => {
        videoJsPlayer.ready(function () {
            const videoPlayer = this;

            videoPlayer.currentTime(0);
            videoPlayer.play();
        });

        tracked = false;
    });

    if (video.dataset.completionUrl) {
        videoJsPlayer.ready(function () {
            const videoPlayer = this;

            videoPlayer.on('timeupdate', () => {
                if (!tracked) {
                    if (videoPlayer.currentTime() > (.9 * videoPlayer.duration())) {
                        quizButton.disabled = false;
                        tracked = true;
                        axios
                            .post(video.dataset.completionUrl)
                            .catch(() => tracked = false);
                    }
                }
            });
        });
    }
}

quizMeButton();
initializeMultiPageTest();
initializeMultiPageTestResults();
